import { useMemo } from "react"

import { PaymentAccountTabLabel } from "../types"

import { usePaymentTermsContext } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"

interface UseCompanyAccountTypesReturn {
  isOneOfType: boolean
  availableTabs: PaymentAccountTabLabel[]
  isCompanyVendor: boolean
  isCompanyCustomer: boolean
}

export const useCompanyAccountTypes = (): UseCompanyAccountTypesReturn => {
  const { isCompanyVendor, isCompanyCustomer } = usePaymentTermsContext()

  const isOneOfType = !(isCompanyVendor && isCompanyCustomer)

  const availableTabs = useMemo(
    () => [
      ...(isCompanyVendor ? [PaymentAccountTabLabel.ACCOUNTS_PAYABLE] : []),
      ...(isCompanyCustomer ? [PaymentAccountTabLabel.ACCOUNTS_RECEIVABLE] : []),
    ],
    [isCompanyVendor, isCompanyCustomer]
  )

  return {
    isOneOfType,
    availableTabs,
    isCompanyVendor,
    isCompanyCustomer,
  }
}
